import React, { Component } from 'react';
import styled from 'styled-components';
import './App.css';
import directory from './directory';
import { connect } from 'react-redux';

const Container = styled.div`
  border-radius: 5px;
  overflow: hidden;
  background-color: white;
  width: 90%;
  margin: auto;
  height: auto;
  margin-top: 10px;


`

const Image = styled.img`
  background-color: transparent;
  width: 100%;
  margin: auto;
  height: auto;
`

const Label = styled.p`
  margin: 2px;
  margin-bottom: 5px;
  padding: 3px;
  font-size: 0.8em;
`

const Button = styled.button`

  overflow: hidden;
  width: 90%;
  margin: auto;
  height: auto;
  padding: 0;
  margin-top: 10px;

  background-color: transparent;
  border: 5px solid white;
  border-radius: 5px;


`;

class Pose extends Component {


  handleAddPoseClick = () => {
    const { indexPath } = this.props;
    this.props.dispatch({type:'PRESENT_MODAL', presentedModal:'ADD_POSE', indexPath:indexPath})
  }

  handleExistingPoseClick = () => {
    const { indexPath } = this.props;
    this.props.dispatch({type:'PRESENT_MODAL', presentedModal:'EXISTING_POSE', indexPath:indexPath})
  }

  handleModalClick = () => {
    const { indexPath, poseIdentifier } = this.props;
    this.props.dispatch({type:'UPDATE_POSE', indexPath:indexPath, newPose:poseIdentifier})
  }

  renderPose = () => {

    const { poseIdentifier, inModal} = this.props;

    console.log(poseIdentifier)
    if (poseIdentifier === "_" && !inModal) {

      return (

          //<Button type="button" onClick={this.handleAddPoseClick}>
             <Image src="http://www.kevinmhealy.com/flowlift/images/add.png"/>
          //</Button>

      );

    } else {

      const title = directory[poseIdentifier];
      const url = "http://www.kevinmhealy.com/flowlift/images/" + poseIdentifier + ".gif"

      return (

        //<Container onClick={inModal ? this.handleModalClick : this.handleExistingPoseClick}>
        <Container >
          <Image src={url} onError={(e)=>{e.target.src="http://www.kevinmhealy.com/flowlift/images/default.png"}}/>
          <Label>{title}</Label>
        </Container>

      );
    }
  }

  render() {
    return (
      this.renderPose()
    );
  }
}

export default connect()(Pose);



// WEBPACK FOOTER //
// ./src/Pose.js